import React from 'react'
import './error.css'

function Error() {
  return (
    <div className='error-container'>
      <h1>404 Not Found!</h1>
    </div>
  )
}

export default Error;